import React from 'react';
import styles from './search-sort.module.scss';
import { useQuerySortOrder as getQuerySortOrder } from '../../../hooks/use-query-sort-order.hook';
import { IDropdown } from '../../../models/dropdown/IDropdown';
import Dropdown from '../../atoms/dropdown/dropdown';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { ReadonlyURLSearchParams } from 'next/navigation';

interface Props {
  sortOptions: IDropdown[];
  router: AppRouterInstance;
  searchParams: ReadonlyURLSearchParams;
  isBreakpointLgUp: boolean;
}

export default function SearchSort({
  sortOptions,
  searchParams,
  isBreakpointLgUp: isBreakpointUp,
}: Props) {
  if (!sortOptions?.length) {
    return null;
  }

  const querySortOrder = getQuerySortOrder(searchParams);
  const sortOrder = querySortOrder.getSortOrder();
  const defaultOption =
    sortOptions.find((option) => option.value.toString() === sortOrder) ??
    sortOptions.find((option) => option.default);

  const dropdown = (
    <Dropdown
      ariaLabel='Sort by'
      defaultValue={defaultOption.value}
      onChange={querySortOrder.setSortOrder}
      options={sortOptions}
      customClass={`${styles[`sort-dropdown`]}`}
      id='sort-by'
    />
  );

  if (isBreakpointUp) {
    return (
      <label className={`${styles[`sort-container`]}`} htmlFor='select'>
        <span>Sort</span> {dropdown}
      </label>
    );
  }

  return (
    <div className={`${styles[`mobile-filter-sortby`]} custom-dropdown position-relative`}>
      {dropdown}
    </div>
  );
}
